/* eslint-disabled */

export default class EngineConditionGroupExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
